import { createContext } from 'react';

import { Customer } from '../interfaces/Customer';
import { Ticket } from '../interfaces/Ticket';

export interface TicketProviderStore {
  customer: Customer | undefined;
  fetchTicket: (id: string) => Promise<Ticket | undefined>;
  isInErrorMode: boolean;
  setCustomer: (customer: Customer) => void;
  setIsInErrorMode: (isInErrorMode: boolean) => void;
  setShowFeedback: (showFeedback: boolean) => void;
  setTicket: (ticket: Ticket) => void;
  showFeedback: boolean;
  ticket: Ticket | undefined;
}

export const TicketContext = createContext({} as TicketProviderStore);
